// src/utils/creditEvent.js

export const CREDIT_UPDATED_EVENT = "credit-updated";

export function emitCreditUpdated() {
    window.dispatchEvent(new Event(CREDIT_UPDATED_EVENT));
}
